import { type PropsWithChildren, type ReactNode, useRef } from "react";

import { getSampleAuthToken } from "@/features/sampleAccount/sampleSessionStorage";
import { configureApiClient, type GetAuthTokenOptions } from "@/lib/api";

import { useAuth } from "@clerk/react";

export function ApiClientProvider({ children }: PropsWithChildren) {
  const auth = useAuth();
  const authRef = useRef(auth);
  authRef.current = auth;

  configureApiClient({
    baseUrl: "/api",
    getAuthToken: async (options?: GetAuthTokenOptions) => {
      // ASA-1594: prefer a sample guest JWT when present (no Clerk session).
      const sampleToken = getSampleAuthToken();
      if (sampleToken) {
        return sampleToken;
      }

      const { getToken, isLoaded, userId } = authRef.current;
      // userId is set for pending sessions where isSignedIn may still be false
      if (!isLoaded || !userId) return null;
      try {
        return await getToken(
          options?.forceRefresh ? { skipCache: true } : undefined,
        );
      } catch {
        return null;
      }
    },
  });

  return children as ReactNode;
}
